import { VoidFunctionComponent } from 'react';
import { Image, Text } from '@react-three/drei';
import { Screen } from '@/components/Screen';
import { useResponsive } from '@/hooks/useResponsive';
import { garamondNarrowLight } from '@/lib/fonts';
import { PlaystationButton } from '@/components/PlaystationButton';
import soldOutImg from '@/img/sold-out.png';
import { BUY_URL } from '@/lib/globals';

interface Props {
    onCancel: () => void;
}
export const SoldOut: VoidFunctionComponent<Props> = ({ onCancel }) => {
    const { responsiveValue } = useResponsive();
    const textProps = {
        textAlign: 'center' as const,
        font: garamondNarrowLight,
        fontSize: responsiveValue(0.36, 0.28),
        color: 'white',
        maxWidth: responsiveValue(5.9, 3.3),
        lineHeight: responsiveValue(1.1, 1.1),
    };

    return (
        <Screen>
            <Image
                position={[0, responsiveValue(1.6, 1.75), 0]}
                scale={2.1}
                color="#FF3333"
                transparent
                url={soldOutImg}
            />
            <Text position={[0, responsiveValue(-0.23, -0.36), 0]} {...textProps}>
                Sorry, the incubator is currently closed. All Onlybots from this batch have been obtained.
            </Text>
            <group
                position={[responsiveValue(-0.8, -0.7), responsiveValue(-1.7, -1.9), 0]}
                scale={responsiveValue(1, 0.85)}
            >
                <PlaystationButton
                    clickableAreaDimensions={[4, 0.7]}
                    maxWidth={4}
                    position={[-1.0, 0, 0]}
                    icon="square"
                    label="ONLYBOTS MARKETPLACE"
                    action={() => {
                        window.location.href = BUY_URL;
                    }}
                />
                <PlaystationButton
                    clickableAreaDimensions={[3, 0.7]}
                    position={[responsiveValue(0.1, 0), responsiveValue(-0.8, -1), 0]}
                    icon="x"
                    label={'CANCEL'}
                    action={onCancel}
                />
            </group>
        </Screen>
    );
};
